export const isValidLocationId = (id?: string): boolean => {
  return !!id && id !== 'index.html' && id !== 'softpay-android';
};

export const isValidNumericLocationId = (id?: number): boolean => {
  return id !== undefined && id !== 0;
};
